import { TenantSubscription } from '../entities/tenant/tenant';
import * as Enumerable from 'linq';

export const TenantPlanFeatures = {
    [TenantSubscription.Core]: [TenantSubscription.Core],
    [TenantSubscription.Starter]: [TenantSubscription.Core],
    [TenantSubscription.Growth]: [TenantSubscription.Core],
    [TenantSubscription.Professional]: [TenantSubscription.Core, TenantSubscription.Professional],
    [TenantSubscription.Enterprise]: [TenantSubscription.Core, TenantSubscription.Professional, TenantSubscription.Enterprise],
    [TenantSubscription.Developer]: [TenantSubscription.Core, TenantSubscription.Professional, TenantSubscription.Enterprise, TenantSubscription.Custom],
} as const;

export interface TenantPlan {
    subscription: TenantSubscription;
    features: {
        [key: string]: boolean;
    },
    addons: {
        [key: string]: boolean;
    }
}

/**
 * Check whether a tenant plan includes the features of a given subscription level.
 * Uses TenantPlanFeatures so higher tiers (e.g. Developer) inherit lower-tier features.
 */
export function tenantPlanIncludes(plan: TenantPlan | null | undefined, level: TenantSubscription): boolean {

    if (!plan?.subscription) return false;

    const features = TenantPlanFeatures[plan.subscription] as readonly TenantSubscription[] | undefined;
    return features?.includes(level) ?? false;
}

export function tenantFeatureEnabled(plan: TenantPlan, feature: string): boolean {
    // HuyLe: the keys come from plan.features, but the check reads plan[key] (plan[key] === true) - it might be meant to read plan.features[key] instead.
    // Just noting what I saw, not changing anything.
    const hasFeature = Enumerable
        .from(Object.keys(plan?.features))
        .any(key => plan[key] === true && key === feature);

    if (hasFeature)
        return true;

    return Enumerable
        .from(Object.keys(plan?.addons))
        .any(key => plan.addons[key] === true && key === feature);
}